var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31413 0.442627C3.63813 0.442627 0.647461 3.43329 0.647461 7.10929V9.87129C0.647461 10.554 1.24546 11.1093 1.98079 11.1093H2.64746C2.82427 11.1093 2.99384 11.0391 3.11887 10.914C3.24389 10.789 3.31413 10.6194 3.31413 10.4426V7.01396C3.31413 6.83715 3.24389 6.66758 3.11887 6.54256C2.99384 6.41753 2.82427 6.34729 2.64746 6.34729H2.04213C2.41279 3.76729 4.63279 1.77596 7.31413 1.77596C9.99546 1.77596 12.2155 3.76729 12.5861 6.34729H11.9808C11.804 6.34729 11.6344 6.41753 11.5094 6.54256C11.3844 6.66758 11.3141 6.83715 11.3141 7.01396V11.1093C11.3141 11.8446 10.7161 12.4426 9.98079 12.4426H8.64746V11.776H5.98079V13.776H9.98079C11.4515 13.776 12.6475 12.58 12.6475 11.1093C13.3828 11.1093 13.9808 10.554 13.9808 9.87129V7.10929C13.9808 3.43329 10.9901 0.442627 7.31413 0.442627Z",
    fill: "#066FDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.3b4115f6d720c5b972333d45d81f5e3d.svg";
export { ForwardRef as ReactComponent };